module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flag-ae22951173806c755ddb1e7183a37ce8.svg";